<template>
  <w-settings-content-template>
    <div slot="content">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-row class="title-bar" type="flex" justify="space-between">
              <div class="vertical-center-box">
                <div class="title-h3 mr-r15">저장소 목록</div>
                <div class="setting-addel mr-r4">
                  <el-button size="mini" @click="onCollectAll(true)"><i class="fas fa-check-square"></i></el-button>
                  <el-button size="mini" @click="onCollectAll(false)"><i class="far fa-square"></i></el-button>
                </div>
                <el-button size="mini" type="primary" @click="showAddIndexPopup">저장소 추가</el-button>
              </div>
              <div class="vertical-center-box" align="right">
                <el-button class="mr-r4" :disabled="checkModifyFlag" type="primary" size="mini" @click="updateIndex">저장</el-button>
                <el-button class="mr-r4" :disabled="checkModifyFlag" size="mini" @click="resetIndexData">취소</el-button>
                <w-header-search-button @click="showSearchHeader"/>
              </div>
            </el-row>
            <!--Index 테이블-->
            <el-row>
              <el-table-wrapper :column-default="columnDefault" row-class-name="c-dblclick" :data="indexData" :columns="indexColumns" :pagination="true" remote
                :show-custom-header="true" :show-search-tool="searchFlag" ref="indexTable" highlight-current-row  @cell-dblclick="showModifyIndexPopup" @cell-click="selectIndex"
                @selection-change="changeSelection" @condition-change="setTableParameter">
                <template slot-scope="scope" slot="creationInterval-slot">
                  <span v-if="scope.row.creationInterval === 'H'">1시간</span>
                  <span v-else>1일</span>
                </template>
                <template slot-scope="scope" slot="retentionAge-slot">
                  {{retentionAgeFormat(scope.row.retentionAge)}}
                </template>
                <template slot-scope="scope" slot="apply-flag-slot">
                  <el-switch v-model="scope.row.useFlag" active-value="Y" inactive-value="N" @change="checkIndexModify"/>
                </template>
              </el-table-wrapper>
            </el-row>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-row class="title-bar" type="flex" justify="space-between">
              <div class="vertical-center-box">
                <div class="title-h3 mr-r15">파싱 패턴</div>
                <div class="setting-addel">
                  <el-button size="mini" @click="showAddPatternPopup"><i class="fas fa-plus"></i></el-button>
                  <el-button size="mini" :disabled="checkSelectionPattern()" @click="deletePattern"><i class="fas fa-minus"></i></el-button>
                </div>
              </div>
              <div class="vertical-center-box" align="right">
                <w-header-search-button @click="showSearchHeaderPattern"/>
              </div>
            </el-row>
            <!--패턴 테이블-->
            <el-row>
              <el-table-wrapper :column-default="columnDefault" row-class-name="c-dblclick" :data="patternData" :columns="patternColumns" :pagination="false"
                :show-custom-header="true" :show-search-tool="searchPatternFlag" ref="logalarmTable" highlight-current-row @cell-dblclick="selectPattern" @selection-change="changePatternSelection">
                <template slot-scope="scope" slot="eventlevel-slot">
                  <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
                </template>
              </el-table-wrapper>
            </el-row>
          </el-row>
        </el-col>
      </el-row>
      <w-index-setting-popup ref="indexSetting" @loadData="loadData" :selectedIndex="indexInfo" :addFlag="addFlag"></w-index-setting-popup>
      <w-pattern-setting-popup ref="patternSetting" @loadData="loadData" @loadPatternData="selectIndex" :selectedIndex="selectedIndex" :selectedPattern="selectedPattern" :addFlag="addFlag"></w-pattern-setting-popup>
    </div>
</w-settings-content-template>
</template>
<script>
import { columnDefault } from '@/constants/table';
import { cloneDeep, isEmpty, differenceWith, isEqual } from 'lodash';
import IndexAPI from '@/api/settings/log/lms-dataindex-setting';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import msgUtil from '@/utils/message';
import WIndexSettingPopup from './popup/IndexSettingPopup';
import WPatternSettingPopup from './popup/PatternSettingPopup';

export default {
  name: 'WIndexSetting',
  components: {
    WSettingsContentTemplate,
    WIndexSettingPopup,
    WPatternSettingPopup,
  },
  data() {
    return {
      limit: 50,
      start: 0,
      searchParams: [],
      columnDefault,
      checkModifyFlag: true,
      addFlag: true,
      searchFlag: false,
      searchPatternFlag: false,
      selectedIndex: {},
      indexInfo: {},
      selectedPattern: {},
      patternData: [],
      indexData: [],
      selectionData: [],
      originIndexData: [],
      selectionPattern: [],
      indexColumns: [
        {
          label: '활성화',
          width: '70',
          prop: 'useFlag',
          scopedSlot: 'apply-flag-slot',
          headerAlign: 'center',
          align: 'center',
        },
        {
          prop: 'dataindexName',
          remoteProp: 'dataindex_name',
          label: '저장소명',
          searchable: true,
          width: 180,
        },
        {
          prop: 'indexPattern',
          remoteProp: 'index_pattern',
          searchable: true,
          label: '저장소 패턴',
        },
        {
          prop: 'retentionAge',
          width: 80,
          scopedSlot: 'retentionAge-slot',
          label: '보관 기간',
        },
        {
          prop: 'creationInterval',
          label: '생성 주기',
          width: 80,
          scopedSlot: 'creationInterval-slot',
        },
      ],
      patternColumns: [
        {
          type: 'selection',
          width: 50,
          prop: 'check_flag',
        },
        {
          prop: 'patternName',
          label: '패턴명',
          searchable: true,
          width: 160,
        },
        {
          prop: 'patternRegex',
          searchable: true,
          label: '패턴',
        },
      ],
    };
  },
  mounted() {
    this.limit = 50;
    this.start = 0;
    this.searchParams = [];
    this.loadData();
  },
  methods: {
    setTableParameter(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.searchParams = value.searchParams;
      this.loadData();
    },
    onCollectAll(value) {
      if (value) {
        // true : 전체 선택
        this.indexData.forEach((item) => {
          item.useFlag = 'Y';
        });
      } else {
        // false : 전체 선택 해제
        this.indexData.forEach((item) => {
          item.useFlag = 'N';
        });
      }
      this.checkIndexModify();
    },

    showSearchHeaderPattern() {
      this.searchPatternFlag = !this.searchPatternFlag;
    },
    showSearchHeader() {
      this.searchFlag = !this.searchFlag;
    },
    /**
     * 저장소 리스트 초기화
     * @author leesy918
     */
    resetIndexData() {
      this.indexData = cloneDeep(this.originIndexData);
      this.checkModifyFlag = true;
    },
    /**
     * 저장소 리스트 변경 여부 체크 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    checkIndexModify() {
      this.checkModifyFlag = isEqual(this.indexData, this.originIndexData);
    },
    /**
     * 저장 버튼 클릭 시 작동 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    updateIndex() {
      const param = differenceWith(this.indexData, this.originIndexData, isEqual);

      IndexAPI.updateDataindex(param).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '저장소', true));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '저장소', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '저장소', false));
        throw new Error(e);
      });
    },
    /**
     * 저장소 선택 체크
     * @author leesy918
     * @return {[type]} [description]
     */
    checkSelection() {
      return isEmpty(this.selectionData);
    },
    checkSelectionPattern() {
      return isEmpty(this.selectionPattern);
    },
    /**
     * 저장소 체크박스 선택
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    changeSelection(data) {
      this.selectionData = data;
    },

    changePatternSelection(value) {
      this.selectionPattern = value;
    },
    /**
     * 저장소 삭제
     * @author leesy918
     * @return {[type]} [description]
     */
    deleteIndex() {
      this.$confirm(...msgUtil.getCustomConfirmData('해당 저장소를 사용하는 로그 수집 설정이 함께 삭제됩니다')).then(() => {
        const param = this.selectionData;
        IndexAPI.deleteDataindex(param).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '저장소', true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '저장소', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '저장소', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    /**
     * 파싱 패턴 삭제
     * @author leesy918
     * @return {[type]} [description]
     */
    deletePattern() {
      this.$confirm(...msgUtil.getCustomConfirmData('해당 파싱패턴을 사용하는 로그 수집 설정이 함께 삭제됩니다')).then(() => {
        const params = this.selectionPattern;
        IndexAPI.deleteDataindexPattern(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '패턴', true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '패턴', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '패턴', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    /**
     * 저장소 데이터 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      const param = {
        limit: this.limit,
        start: this.start,
        searchParams: this.searchParams,
      };
      IndexAPI.getLmsDataindexList(param).then((response) => {
        if (response.data.success) {
          this.originIndexData = cloneDeep(response.data.data);
          this.indexData = response.data.data;
          if (!isEmpty(response.data.data)) {
            this.$nextTick(() => {
              this.$refs.indexTable.$children[0].setCurrentRow(this.indexData[0]);
              this.selectedIndex = this.indexData[0];
              this.checkIndexModify();
              if (isEmpty(this.indexData[0])) {
                this.patternData = [];
              } else {
                this.selectIndex(this.indexData[0]);
              }
              this.addFlag = false;
            });
          }
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '저장소 정보', false));
        throw new Error(e);
      });
    },
    /**
     * 생성일 포멧
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    retentionAgeFormat(data) {
      return `${data}일`;
    },
    /**
     * 저장소 추가 버튼 클릭
     * @author leesy918
     */
    showAddIndexPopup() {
      this.addFlag = true;
      this.$refs.indexSetting.open();
    },
    /**
     * 저장소 선택 시 파싱 패턴 목록 로드
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    selectIndex(data) {
      this.selectedIndex = cloneDeep(data);
      const params = {
        dataindexId: this.selectedIndex.dataindexId,
      };
      IndexAPI.getDataindexPattern(params).then((response) => {
        if (response.data.success) {
          this.patternData = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '파싱 패턴', false));
        throw new Error(e);
      });
    },
    /**
     * 저장소 더블 클릭시 작동 합수
     * @author leesy918
     * @return {[type]} [description]
     */
    showModifyIndexPopup(data) {
      this.indexInfo = data;
      this.addFlag = false;
      this.$refs.indexSetting.open();
    },
    /**
     * 패턴 선택
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    selectPattern(data) {
      this.selectedPattern = cloneDeep(data);
      this.addFlag = false;
      this.$refs.patternSetting.open();
    },
    /**
     * 패턴 추가 팝업 출력
     * @author leesy918
     */
    showAddPatternPopup() {
      this.addFlag = true;
      this.$refs.patternSetting.open();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/LogIndex/index.vue